import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateCatalogSortingSelector = createSelector(testTargetOffersSelector, offers => offers.updateCatalogSorting || Empty.Object);

export { updateCatalogSortingSelector };
